import React from 'react';
import ShortcutsSettingsSection from './settings/ShortcutsSettingsSection';

const SettingsView = () => {
  return (
    <div>
      <ShortcutsSettingsSection />
    </div>
  );
};

export default SettingsView;

